// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\DateTimeDisplaySettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DateDisplayOrder } from 'server/enums/DateDisplayOrder';

// DateTimeDisplaySettingsData is the class that DateTimeDisplaySettings serializes to/from
export interface DateTimeDisplaySettingsData {
	
	
    DateOrder : DateDisplayOrder;
    DateSeparator : string;
    TimeSeparator : string;
}

// DateTimeDisplaySettingsOptions is the class which may be passed to the DateTimeDisplaySettings constructor to define optional initial data values
export interface DateTimeDisplaySettingsOptions {
	
	
    DateOrder? : DateDisplayOrder;
    DateSeparator? : string;
    TimeSeparator? : string;
}

export class DateTimeDisplaySettings {
	
	
    public DateOrder : DataSignal<DateDisplayOrder>;
    public DateSeparator : DataSignal<string>;
    public TimeSeparator : DataSignal<string>;

    constructor();
    constructor(data : DateTimeDisplaySettingsOptions);
    constructor(data: DateTimeDisplaySettingsOptions | null = null) {
	    
	    
        this.DateOrder = jsonableObservable(S.value<DateDisplayOrder>(data && data.DateOrder !== undefined ? data.DateOrder : 0));
        this.DateSeparator = jsonableObservable(S.value<string>(data && data.DateSeparator !== undefined ? data.DateSeparator : ''));
        this.TimeSeparator = jsonableObservable(S.value<string>(data && data.TimeSeparator !== undefined ? data.TimeSeparator : ''));
    }

    static key(obj : DateTimeDisplaySettings) {
        return ;
    }
    
    static dataKey(obj : DateTimeDisplaySettingsOptions) {
        return ;
    }

    static update(obj : DateTimeDisplaySettings, data : DateTimeDisplaySettingsOptions) {
        S.freeze(() => {
	        
	        
            if (data.DateOrder !== undefined) obj.DateOrder(data.DateOrder);
            if (data.DateSeparator !== undefined) obj.DateSeparator(data.DateSeparator);
            if (data.TimeSeparator !== undefined) obj.TimeSeparator(data.TimeSeparator);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DateTimeDisplaySettings.ts